import React                            from 'react';
import {
  Form,
  Field,
  Formik,
  FormikProps,
}                                       from 'formik';
import styled                           from 'styled-components';
import { Grid }                         from '@material-ui/core';
import { Button, TextInput }            from '@components/index';
import { IForgotPasswordInitialValues } from '@typings/auth';

const Wrapper = styled.div`
  width: 300px;
`;

const TitleWrapper = styled.div`
  font-size     : 28px;
  font-weight   : 500;
  color         : ${({ theme: { textColor } }): string => textColor.secondary};
`;

const InputWrapper = styled.div`
  position: relative;
`;

const LabelWrapper = styled.p`
  position      : absolute;
  left          : -210px;
  top           : 20px;
  width         : 200px;
  padding-right : 10px;
  font-size     : 18px;
  font-weight   : 500;
  text-align    : right;
  color         : ${({ theme: { textColor } }): string => textColor.black};
`;

const HintWrapper = styled.div`
  font-size   : 16px;
  font-weight : bold;
  margin      : 5px 0;
  text-align  : center;
  color       : ${({ theme: { textColor } }): string => textColor.darkGray};
`;

const StyledInput = styled(TextInput)`
  && input {
    font-weight      : 400;
    font-size        : 16px;
    height           : 35px;
    background-color : ${({ theme: { backgroundColor } }): string => backgroundColor.white};
    color            : ${({ theme: { textColor } }): string => textColor.gray} !important;
  }
`;

interface IProps {
  isEmailSending         : boolean;
  initialValues          : IForgotPasswordInitialValues;
  validationSchema       : object;
  handleSendRecoveryMail : (values: IForgotPasswordInitialValues) => void;
}

export const ForgotPassword: React.FC<IProps> = ({
  isEmailSending,
  initialValues,
  validationSchema,
  handleSendRecoveryMail,
}) => (
  <Formik
    onSubmit         = {handleSendRecoveryMail}
    initialValues    = {initialValues}
    validationSchema = {validationSchema}
    validateOnMount
  >
    {({
      dirty,
      errors,
      touched,
      isValid,
      isSubmitting,
    }: FormikProps<IForgotPasswordInitialValues>): JSX.Element => (
      <Form>
        <Wrapper>
          <Grid container spacing={2} justify="center">
            <Grid item xs={12}>
              <TitleWrapper>Forgot Password?</TitleWrapper>
            </Grid>

            <Grid item xs={12}>
              <InputWrapper>
                <LabelWrapper>Email</LabelWrapper>
                <Field
                  id          = "email"
                  name        = "email"
                  type        = "email"
                  placeholder = "Email"
                  error       = {touched.email && !!errors.email}
                  component   = {StyledInput}
                />
              </InputWrapper>
            </Grid>

            <Grid item xs={12}>
              <HintWrapper>
                Enter your email address to have a password recovery email sent.
              </HintWrapper>
            </Grid>

            <Grid item xs={12}>
              <Button
                type      = "submit"
                label     = "Send Email"
                margin    = "0"
                isLoading = {isEmailSending || isSubmitting}
                disabled  = {!isValid || !dirty || isEmailSending || isSubmitting}
                fullWidth
              />
            </Grid>
          </Grid>
        </Wrapper>
      </Form>
    )}
  </Formik>
);
